import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import Button from '../../Button'

const RestartStreamDialog = ({ poster, onLiveStreamClicked }) => (
  <div className="RestartStreamDialog" style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${poster})` }}>
    <div className="control-dialog">
      <Button
        handleClick={onLiveStreamClicked}
        text="Watch Live"
      />
    </div>
    <style jsx>{styles}</style>
  </div>
)

RestartStreamDialog.propTypes = {
  poster: PropTypes.string,
  onLiveStreamClicked: PropTypes.func.isRequired,
}

RestartStreamDialog.defaultProps = {
  poster: null,
}

export default RestartStreamDialog
